import clsx from 'clsx'
import React, { ReactElement } from 'react'

import s from './styles.module.scss'

export const Tag = ({
  className,
  classNameIcon,
  Icon,
  label,
  onClick,
}: {
  className?: string
  classNameIcon?: string
  Icon?: any
  label: string | ReactElement
  onClick?: (e?: any) => void
}) => {
  return (
    <div className={clsx(s.tag, className)} onClick={onClick}>
      {Icon && <div className={clsx(s.icon, classNameIcon)}>{Icon}</div>}
      {label}
    </div>
  )
}
